import {EXPEDITION_LIST_CONTEXT} from '../../helper/expeditionListContext';

const INITIAL_STATE = {
    items: []
};

const PENDING_MENU_PATH = {
    [EXPEDITION_LIST_CONTEXT.EXPEDITION]: '/expedition/pending',
    [EXPEDITION_LIST_CONTEXT.RESUMAPS]: '/expedition/resumapas/pending',
};

function applyPendingBadgeToItems(items, pendingUrl, total) {
    if (!Array.isArray(items)) {
        return;
    }
    items.forEach((item) => {
        if (!item || !item.children || !Array.isArray(item.children)) {
            return;
        }
        item.children.filter((c) => c && c.to === pendingUrl).forEach((childItem) => {
            if (total > 0) {
                childItem.badge = {
                    variant: 'danger',
                    text: total,
                };
            } else {
                childItem.badge = {};
            }
        });
    });
}

export default (state = INITIAL_STATE, action) => {
    if (action.type === 'SET_PENDING_NAV_ITEM') {
        const { context, total } = action.payload;
        const pendingUrl = PENDING_MENU_PATH[context];
        if (!pendingUrl) {
            return state;
        }
        const items = state.items;
        if (!Array.isArray(items)) {
            return state;
        }
        applyPendingBadgeToItems(items, pendingUrl, total);
        return {...state, items};
    }

    if (action.type === 'SET_NAVIGATION') {
        if (!Array.isArray(action.payload)) {
            return state;
        }
        return {...state, items: action.payload};
    }
    return state;
};
